module.exports = __webpack_public_path__ + "static/media/linkedin.2941b64b.svg";